import { render, staticRenderFns } from "./SelectPrefecture.vue?vue&type=template&id=57b7cba6&scoped=true&lang=pug&"
import script from "./SelectPrefecture.vue?vue&type=script&lang=ts&"
export * from "./SelectPrefecture.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPrefecture.vue?vue&type=style&index=0&id=57b7cba6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b7cba6",
  null
  
)

export default component.exports